// src/index.ts
import {
  WebTracerProvider,
  BatchSpanProcessor
} from "@opentelemetry/sdk-trace-web";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { Resource } from "@opentelemetry/resources";
import { SemanticResourceAttributes } from "@opentelemetry/semantic-conventions";
import { W3CTraceContextPropagator } from "@opentelemetry/core";
import { propagation, context } from "@opentelemetry/api";
import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
var initialized = false;
var provider = null;
function initTracing(config) {
  if (initialized) return;
  initialized = true;
  try {
    _initTracingUnsafe(config);
  } catch (err) {
    console.warn("[OTel] Tracing init failed \u2014 app continues without tracing", err);
  }
}
function _initTracingUnsafe(config) {
  const { serviceName, serviceVersion = "0.0.0", environment = "local", collectorUrl } = config;
  if (!collectorUrl) {
    console.debug("[OTel] No collectorUrl configured \u2014 tracing disabled");
    return;
  }
  const resolvedUrl = collectorUrl.startsWith("/") ? `${window.location.origin}${collectorUrl}` : collectorUrl;
  const resource = new Resource({
    [SemanticResourceAttributes.SERVICE_NAME]: serviceName,
    [SemanticResourceAttributes.SERVICE_VERSION]: serviceVersion,
    "deployment.environment": environment
  });
  const exporter = new OTLPTraceExporter({
    url: resolvedUrl,
    headers: {}
  });
  provider = new WebTracerProvider({
    resource,
    spanProcessors: [new BatchSpanProcessor(exporter, {
      maxQueueSize: 100,
      scheduledDelayMillis: 5e3,
      exportTimeoutMillis: 3e4,
      maxExportBatchSize: 10
    })]
  });
  propagation.setGlobalPropagator(new W3CTraceContextPropagator());
  provider.register();
  registerInstrumentations({
    tracerProvider: provider,
    instrumentations: [
      getWebAutoInstrumentations({
        "@opentelemetry/instrumentation-fetch": {
          enabled: true,
          // Only inject traceparent on same-origin requests — external APIs
          // (tile servers, CDNs) reject the extra header via CORS preflight.
          propagateTraceHeaderCorsUrls: [new RegExp(`^${window.location.origin}`)],
          clearTimingResources: true
        },
        "@opentelemetry/instrumentation-xml-http-request": {
          enabled: false
          // Use fetch only
        },
        "@opentelemetry/instrumentation-document-load": {
          enabled: true
        }
      })
    ]
  });
  console.debug("[OTel] Browser tracing initialized, service:", serviceName, "collector:", resolvedUrl);
}
async function shutdownTracing() {
  if (provider) {
    await provider.shutdown();
  }
}
function getCurrentTraceparent() {
  const headers = {};
  propagation.inject(context.active(), headers, {
    set(carrier, key, value) {
      carrier[key] = value;
    }
  });
  return headers["traceparent"] ?? null;
}
export {
  getCurrentTraceparent,
  initTracing,
  shutdownTracing
};
//# sourceMappingURL=index.js.map